import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <a
        href="https://t.ly/Oo1Ik"
        className="btn"
        target="_blank"
        rel="noreferrer"
      >
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
